import React, { useState } from 'react';
import { TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as themeService from '../../../services/ThemeService';
import './addTheme.scss';
import BackButton from './../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const AddTheme = () => {
  const [nomTheme, setNomTheme] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (nomTheme.length < 5) {
      Swal.fire(
        'Erreur',
        'Le nom du thème doit avoir au moins 5 caractères.',
        'error'
      );
      return;
    }
    setIsLoading(true);

    try {
      const res = await themeService.addTheme(nomTheme);
      if (res.status === 201) {
        Swal.fire(
          'Thème créé !',
          'Création du Thème avec succès!',
          'success'
        );
        setTimeout(() => {
          navigate("/theme");
        }, 2000);
      } else {
        Swal.fire(
          'Erreur',
          'Une erreur s\'est produite',
          'error'
        );
      }
    } catch (err) {
      console.error("Erreur lors de l'ajout du thème :", err);
      Swal.fire(
        'Erreur',
        'Une erreur s\'est produite',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="addTheme">
        <span className="titre">Nouveau Thème</span>

        <div className="form-theme">
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              placeholder="Nom du thème..."
              variant="outlined"
              margin="normal"
              maxRows={1000}
              onChange={(e) => setNomTheme(e.target.value)}
              required
            />
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTheme;